import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card-title" }
const _hoisted_2 = { class: "column q-mb-md" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Link Title ")
const _hoisted_4 = { class: "column q-mb-md" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" URL ")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Cancel", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    modelValue: _ctx.getDisplayAddLinkPopin,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.getDisplayAddLinkPopin) = $event)),
    onBeforeShow: _ctx.beforeShow
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { class: "popin" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "row items-center q-pb-none" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createTextVNode(_toDisplayString(_ctx.isEditMode ? "Update" : "Add ") + " your links ", 1 /* TEXT */),
                _createVNode(_component_q_icon, { name: "link" })
              ]),
              _createVNode(_component_q_space),
              _createVNode(_component_q_btn, {
                icon: "close",
                flat: "",
                round: "",
                dense: "",
                "data-test": "button-close",
                onClick: _ctx.onClose
              }, null, 8 /* PROPS */, ["onClick"])
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
              _createElementVNode("form", {
                class: "column",
                onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
              }, [
                _createElementVNode("label", _hoisted_2, [
                  _hoisted_3,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.title) = $event)),
                    required: ""
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelText, _ctx.title]
                  ])
                ]),
                _createElementVNode("label", _hoisted_4, [
                  _hoisted_5,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.url) = $event)),
                    required: ""
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelText, _ctx.url]
                  ])
                ]),
                _createVNode(_component_q_card_actions, { align: "right" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_btn, {
                      outline: "",
                      rounded: "",
                      "no-caps": "",
                      class: "main-button",
                      type: "button",
                      onClick: _ctx.onClose
                    }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"]),
                    _createVNode(_component_q_btn, {
                      outline: "",
                      rounded: "",
                      "no-caps": "",
                      class: "action-button",
                      type: "submit"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(_ctx.isEditMode ? "Update" : "Add"), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                })
              ], 32 /* HYDRATE_EVENTS */)
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["modelValue", "onBeforeShow"]))
}